// API of the multi-tenant package "consultcal": Admin → Companies → Consultation appointments.
import { apiRequest } from '../api';

export interface ConsultCalendarView {
  mailboxEmail: string;                                   // the invoice mailbox ('' = not chosen)
  calendarId: string;                                     // the calendar written to ('' = not chosen)
  effective: { ready: boolean; error: string; mailbox: string; calendar: string };
  accounts: { email: string; name: string }[];            // connected mailboxes to choose from
  calendars: { id: string; email: string; label: string }[];   // the Calendar page's own calendars
  lastRun: { at: number; candidates: number; created: number; moved: number; cancelled: number; errors: string[] };
}
export interface ConsultCalendarSave {
  mailboxEmail?: string;
  calendarId?: string;
}
export interface ConsultCalendarTest {
  emailsScanned: number; candidates: number;
  created: number; moved: number; unchanged: number; cancelled: number; past: number; stale: number;
  appointments: { invoiceNo: string; client: string; date: string; time: string; minutes: number; action: string }[];
  errors: string[];
}

export const consultcalApi = {
  get: (): Promise<ConsultCalendarView> => apiRequest('GET', '/admin/consult-calendar'),
  save: (data: ConsultCalendarSave): Promise<ConsultCalendarView> => apiRequest('PUT', '/admin/consult-calendar', data),
  test: (): Promise<ConsultCalendarTest> => apiRequest('POST', '/admin/consult-calendar/test'),
};
